import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  fallbackPath?: string;
  label?: string;
  sx?: object;
}

const BackButton: React.FC<BackButtonProps> = ({ fallbackPath = '/', label = 'Back', sx }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };

  return (
    <Tooltip title={label}>
      <IconButton onClick={handleBack} sx={sx} aria-label={label} color="primary">
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );
};

export default BackButton; 